import Complete from "./Complete/index.js";
class Index {
    rc;
    _parent;
    taskId;
    constructor(_parent, taskId = null) {
        this._parent = _parent;
        this.rc = _parent.rc;
        this.taskId = taskId;
    }
    path(withParameter = true) {
        if (withParameter && this.taskId !== null) {
            return `${this._parent.path()}/tasks/${this.taskId}`;
        }
        return `${this._parent.path()}/tasks`;
    }
    /**
     * Returns information about the specified task(s) by ID(s).
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/tasks/{taskId}
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */
    async get(restRequestConfig) {
        if (this.taskId === null) {
            throw new Error("taskId must be specified.");
        }
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes the specified task.
     * HTTP Method: delete
     * Endpoint: /team-messaging/v1/tasks/{taskId}
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */
    async delete(restRequestConfig) {
        if (this.taskId === null) {
            throw new Error("taskId must be specified.");
        }
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates the specified task by ID.
     * HTTP Method: patch
     * Endpoint: /team-messaging/v1/tasks/{taskId}
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */
    async patch(tMUpdateTaskRequest, restRequestConfig) {
        if (this.taskId === null) {
            throw new Error("taskId must be specified.");
        }
        const r = await this.rc.patch(this.path(), tMUpdateTaskRequest, undefined, restRequestConfig);
        return r.data;
    }
    complete() {
        return new Complete(this);
    }
}
export default Index;
